var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.dataLoaded ? _c('div', {
    staticClass: "text-center"
  }, [_c('v-progress-circular', {
    staticClass: "mt-6",
    attrs: {
      "size": 50,
      "color": "primary",
      "indeterminate": ""
    }
  })], 1) : _c('div', {
    staticClass: "mt-4"
  }, [_c('v-row', {
    staticClass: "my-0"
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'protocols'
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-chevron-left")]), _vm._v(" Назад ")], 1), _c('v-btn', {
    staticClass: "white--text px-4",
    attrs: {
      "outlined": "",
      "small": "",
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v("Добавить ")], 1)], 1)], 1), _c('PageTable', {
    attrs: {
      "table-loading": _vm.tableLoading,
      "table-headers": _vm.tableHeaders,
      "table-items": _vm.protocolLinesDTO.list,
      "filter": ""
    },
    scopedSlots: _vm._u([{
      key: "item.decision.name",
      fn: function fn(_ref) {
        var application = _ref.item;
        return [_c('v-edit-dialog', {
          attrs: {
            "return-value": application.decision,
            "large": "",
            "persistent": "",
            "save-text": "сохранить",
            "cancel-text": "отмена"
          },
          on: {
            "update:returnValue": function updateReturnValue($event) {
              return _vm.$set(application, "decision", $event);
            },
            "update:return-value": function updateReturnValue($event) {
              return _vm.$set(application, "decision", $event);
            },
            "save": function save($event) {
              return _vm.saveDecision(application);
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function fn() {
              return [_c('v-autocomplete', {
                staticClass: "mt-2",
                attrs: {
                  "label": "Решение",
                  "placeholder": "Выберите из списка",
                  "no-data-text": "Список пуст",
                  "items": _vm.decisions,
                  "item-text": "name",
                  "outlined": "",
                  "rounded": "",
                  "dense": "",
                  "return-object": "",
                  "hide-details": ""
                },
                model: {
                  value: application.decision,
                  callback: function callback($$v) {
                    _vm.$set(application, "decision", $$v);
                  },
                  expression: "application.decision"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_c('div', [_vm._v(" " + _vm._s(application.decision.name) + " "), _c('v-icon', {
          attrs: {
            "small": "",
            "color": "lightGrey"
          }
        }, [_vm._v("mdi-pencil-outline")])], 1)])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-icon', {
          staticClass: "remove-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Удалить"
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v(" mdi-trash-can-outline ")])];
      }
    }])
  })], 1)], 1)], 1), _c('ProtocolLineDialog', {
    attrs: {
      "dialog": _vm.dialog,
      "saveBtnLoading": _vm.btnLoading,
      "selectedItem": _vm.selectedItem,
      "isShowMode": _vm.isShowMode
    },
    on: {
      "saveProtocolLine": _vm.saveProtocolLine,
      "closeModal": _vm.closeDialog
    }
  }), _c('ConfirmDialog', {
    attrs: {
      "dialog": _vm.confirmDialog,
      "loading": _vm.btnLoading,
      "message": "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0438\u0437 \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430?"
    },
    on: {
      "confirm": _vm.removeProtocolLine,
      "closeModal": _vm.closeDialog
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }